import _extends from "@babel/runtime/helpers/esm/extends";
import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
import React from 'react';
import { shape, string, func, number, bool } from 'prop-types';
import { ChangeLink, Container, Label, PinIcon, Disabled, LoadingIcon } from './shipping-button.styles';
import { locationText as getLocationText } from '../../utils';

const ShippingButton = _ref => {
  let {
    placeholder,
    changeLabel,
    actionLabel,
    disabled,
    done,
    loading,
    onClick,
    location,
    maxCityLength
  } = _ref,
      props = _objectWithoutPropertiesLoose(_ref, ["placeholder", "changeLabel", "actionLabel", "disabled", "done", "loading", "onClick", "location", "maxCityLength"]);

  const locationText = location && Object.keys(location).length ? getLocationText(Object.assign({}, location, {
    maxCityLength,
    includeAddress: false
  })) : '';
  return /*#__PURE__*/React.createElement(Container, _extends({}, props, {
    onClick: loading || disabled ? () => {} : onClick,
    "data-testid": "shipping-button"
  }), (loading || disabled) && /*#__PURE__*/React.createElement(Disabled, {
    "data-testid": "shipping-disabled"
  }, loading && /*#__PURE__*/React.createElement(LoadingIcon, null)), /*#__PURE__*/React.createElement(PinIcon, {
    fill: "primary.base"
  }), /*#__PURE__*/React.createElement(Label, {
    as: "span"
  }, locationText || placeholder), !!locationText && /*#__PURE__*/React.createElement(ChangeLink, {
    as: "span"
  }, done ? changeLabel : actionLabel));
};

ShippingButton.defaultProps = {
  placeholder: 'Calcular frete e prazo',
  changeLabel: 'alterar',
  actionLabel: 'calcular',
  disabled: false,
  loading: false,
  done: false,
  onClick: () => {},
  location: {},
  maxCityLength: 24
};
process.env.NODE_ENV !== "production" ? ShippingButton.propTypes = {
  placeholder: string,
  changeLabel: string,
  actionLabel: string,
  disabled: bool,
  loading: bool,
  done: bool,
  onClick: func,
  location: shape({
    zipCode: string,
    zipCodeCity: string,
    zipCodeState: string
  }),
  maxCityLength: number
} : void 0;
export default ShippingButton;